export default `vec3 q=p;
    float s=5., e=0.;
    for(int j=0;j++<8;s*=e)
      p=sign(p)*(1.-abs(abs(p-2.)-1.)),
      p=p*(e=6./clamp(dot(p,p),.1,3.))-q*vec3(2.0,8.0,5.0);
    return length(p)/s;
  }`